module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "equipment-services",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('legend', {
    staticClass: "equipment-services-title"
  }, [_vm._v(_vm._s(_vm.$t('EquipmentServices.title')))]), _vm._v(" "), _c('p', {
    staticClass: "equipment-services-hint"
  }, [_vm._v(_vm._s(_vm.$t('EquipmentServices.hint')))]), _vm._v(" "), _c('div', {
    staticClass: "equipment-services-options"
  }, _vm._l((_vm.rows), function(row) {
    return _c('button', {
      key: row.key,
      staticClass: "equipment-service",
      class: _vm.optionClass(row),
      attrs: {
        "type": "button",
        "role": "checkbox",
        "aria-checked": _vm.isSelected(row.key) ? 'true' : 'false',
        "aria-label": _vm.chipLabel(row),
        "title": _vm.hintFor(row),
        "disabled": _vm.disabled || (!_vm.isSelected(row.key) && _vm.isBlocked(row)) || (_vm.isSelected(row.key) && _vm.isLocked(row))
      },
      on: {
        "click": function($event) {
          _vm.toggle(row.key, !_vm.isSelected(row.key))
        }
      }
    }, [(_vm.isSelected(row.key)) ? _c('v-icon', {
      staticClass: "equipment-service-check",
      attrs: {
        "size": "14"
      }
    }, [_vm._v("mdi-check")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "equipment-service-name"
    }, [_vm._v(_vm._s(_vm.$t('EquipmentServices.' + row.key)))]), _vm._v(" "), _c('span', {
      staticClass: "equipment-service-count"
    }, [_vm._v(_vm._s(row.assigned) + "/" + _vm._s(row.contracted))])], 1)
  }), 0), _vm._v(" "), (!_vm.value.length) ? _c('p', {
    staticClass: "equipment-services-error"
  }, [_vm._v(_vm._s(_vm.$t('EquipmentServices.required')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ee8b470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldSurveys/SurveyWorkServices.vue
// module id = 1745
// module chunks = 0